<!-- user-center-common 关于我们 -->

<template>
  <div v-wechat-title="title" style="margin: 8px" v-html="detail"></div>
</template>

<script>
import { getSysConfigValue } from "@/api/sys-api"
import { $wx_kefu_rc, $sys_config_key_suffix } from "@/util/wxSdk"

export default {
  name: "common",

  data() {
    return {
      detail: '',
      title: ''
    }
  },

  created() {
    const typeName = this.$route.query.type;
    budo_log.info("#19 created", typeName)

    switch (typeName) {
      case 'service':
        this.title = '在线客服'
        location.href = $wx_kefu_rc()
        break
      case 'about':
        this.title = '关于我们'
        getSysConfigValue('Page_About' + $sys_config_key_suffix()).then(res => {
          this.detail = res.data || "关于我们 暂无内容"
        })
        break
      case 'agreement':
        this.title = '用户协议'
        getSysConfigValue('Page_Agreement' + $sys_config_key_suffix()).then(res => {
          this.detail = res.data || "用户协议 暂无内容"
        })
        break
      case 'privacy':
        this.title = '隐私政策'
        getSysConfigValue('Page_Privacy' + $sys_config_key_suffix()).then(res => {
          this.detail = res.data || "隐私政策 暂无内容"
        })
        break
      case 'feedback':
        this.title = '意见反馈'
        getSysConfigValue('Page_Feedback' + $sys_config_key_suffix()).then(res => {
          this.detail = res.data || "意见反馈 暂无内容"
        })
        break
    }
  }
}
</script>
